import {
  campusEnums,
  personaEnums,
  programEnums,
} from '../../enums'
import { ProgramModel } from '../../models'
import personas from '../../utils/static-data/personas'
import { FeatureFlagStore } from '../types'

export { default as initialHiddenFormParams } from './hiddenFormParams'
export { default as initialQuizState } from './quiz'

export const initialCampusState = campusEnums.codes.UNKNOWN
export const initialFormRedirect = new URL(
  '/confirmation/ready/',
  typeof window !== 'undefined' ? window.location.origin : 'https://www.ultimatemedical.edu',
)
export const initialLeadID = ''
export const initialPersonaState = { ...personas[personaEnums.personas.INITIAL] }
export const initialProgramState = new ProgramModel({
  code: programEnums.codes.UNKNOWN,
})
export const initialSearchModalOpenState = false
export const initialFeatureFlags: FeatureFlagStore = {
  newConfirmationPage: false,
}
